// extracted by mini-css-extract-plugin
export default {"fieldview":"f8d92367aeaaac5c4797","bordertop":"feb19f5493d8626e5b47","header":"b0ebfcfd23310c561f81"};